import { FSharpRef, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, array_type, class_type, int32_type, string_type, record_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { NewEvent, Region_$reflection, User_$reflection, Course_$reflection } from "../Shared/SharedModels.jsx";
import { tap, PromiseBuilder__TryFinally_7D49A2FD, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Event$, toastServerError, Region, User, Course } from "../ApiClient.jsx";
import { Result_ToOption } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { orElseWith, toArray, bind, map as map_1, defaultArg, map3 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { tryParse, minValue, minute, hour, now, compare, day, month, utcNow, year, create, toUniversalTime } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { take, length, forAll, tryHead, empty, append, singleton as singleton_1, iterate, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { tryFind, sortBy, map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { equals, comparePrimitives, int32ToString, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { DialogActions, Caption1, tokens, Textarea, Switch, Divider, Input, SpinButton, Option, Dropdown, Field, DialogContent, DialogTitle, DialogBody, DialogSurface, Button, DialogTrigger, Dialog as Dialog_1, useComboboxFilter, Combobox, Text as Text$, Avatar } from "@fluentui/react-components";
import { empty as empty_1, toArray as toArray_1, singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { SaveRegular, WarningRegular, DismissRegular, InfoRegular, AddRegular } from "@fluentui/react-icons";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { isNumber } from "../fable_modules/fable-library-js.4.24.0/Char.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Int32.js";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { nb } from "date-fns/locale";
import { setHours, format as format_1 } from "date-fns";
import { TimePicker } from "@fluentui/react-timepicker-compat";
import { TimeSelectionDataModule_parse } from "../fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";

class Model extends Record {
    constructor(Form, Prerequisites, IsOpen, IsSending, IsFetchingPrerequisites) {
        super();
        this.Form = Form;
        this.Prerequisites = Prerequisites;
        this.IsOpen = IsOpen;
        this.IsSending = IsSending;
        this.IsFetchingPrerequisites = IsFetchingPrerequisites;
    }
}

function Model_$reflection() {
    return record_type("AddEvent.Model", [], Model, () => [["Form", option_type(NewEventForm_$reflection())], ["Prerequisites", option_type(EventPrerequisites_$reflection())], ["IsOpen", bool_type], ["IsSending", bool_type], ["IsFetchingPrerequisites", bool_type]]);
}

class NewEventForm extends Record {
    constructor(Name, Enabled, Summary, Description, Address, MaxAttendees, Time, TeacherId, CourseId, RegionId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.Time = Time;
        this.TeacherId = TeacherId;
        this.CourseId = (CourseId | 0);
        this.RegionId = RegionId;
    }
}

function NewEventForm_$reflection() {
    return record_type("AddEvent.NewEventForm", [], NewEventForm, () => [["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", option_type(string_type)], ["MaxAttendees", int32_type], ["Time", class_type("System.DateTime")], ["TeacherId", option_type(int32_type)], ["CourseId", int32_type], ["RegionId", option_type(int32_type)]]);
}

class EventPrerequisites extends Record {
    constructor(AllCourses, AllUsers, AllRegions) {
        super();
        this.AllCourses = AllCourses;
        this.AllUsers = AllUsers;
        this.AllRegions = AllRegions;
    }
}

function EventPrerequisites_$reflection() {
    return record_type("AddEvent.EventPrerequisites", [], EventPrerequisites, () => [["AllCourses", array_type(Course_$reflection())], ["AllUsers", array_type(User_$reflection())], ["AllRegions", array_type(Region_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateForm", "UpdatePrerequisites", "UpdateIsOpen", "UpdateIsSending", "UpdateIsFetchingPrerequisites"];
    }
}

function Msg_$reflection() {
    return union_type("AddEvent.Msg", [], Msg, () => [[["Item", option_type(NewEventForm_$reflection())]], [["Item", option_type(EventPrerequisites_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Form, msg.fields[0], model.IsOpen, model.IsSending, model.IsFetchingPrerequisites);
        case 2:
            return new Model(model.Form, model.Prerequisites, msg.fields[0], model.IsSending, model.IsFetchingPrerequisites);
        case 3:
            return new Model(model.Form, model.Prerequisites, model.IsOpen, msg.fields[0], model.IsFetchingPrerequisites);
        case 4:
            return new Model(model.Form, model.Prerequisites, model.IsOpen, model.IsSending, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.Prerequisites, model.IsOpen, model.IsSending, model.IsFetchingPrerequisites);
    }
}

function init() {
    return new Model(undefined, undefined, false, false, true);
}

function Promises_fetchPrerequisites(dispatch, setCtx) {
    let pr_4;
    const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__TryFinally_7D49A2FD(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr, pr_1, pr_2;
        return (Promise.all([((pr = tap((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "fetchCoursesError", "Kunne ikke hente kurs", "Noe gikk galt", undefined);
            }
        }, startAsPromise(Course.GetAllCourses())), pr.then(Result_ToOption))), ((pr_1 = tap((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchUsersError", "Kunne ikke hente brukere", "Noe gikk galt", undefined);
            }
        }, startAsPromise(User.GetAll())), pr_1.then(Result_ToOption))), ((pr_2 = tap((res_2) => {
            if (res_2.tag === 1) {
                errorToast(setCtx, "fetchRegionsError", "Kunne ikke hente regioner", "Noe gikk galt", undefined);
            }
        }, startAsPromise(Region.GetAllRegions())), pr_2.then(Result_ToOption)))])).then((_arg) => {
            dispatch(new Msg(1, [map3((courses$0027, users$0027, regions$0027) => (new EventPrerequisites(courses$0027, users$0027, regions$0027)), _arg[0], _arg[1], _arg[2])]));
            return Promise.resolve();
        });
    }), () => {
        dispatch(new Msg(4, [false]));
    })));
    pr_4 = (pr_3.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
    void pr_4;
}

function Promises_addEvent(form, appendEvent, dispatch, setCtx) {
    const matchValue = form.Address;
    const matchValue_1 = form.TeacherId;
    const matchValue_2 = form.RegionId;
    let matchResult, address, regionId, teacherId;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            if (matchValue_2 != null) {
                matchResult = 0;
                address = matchValue;
                regionId = matchValue_2;
                teacherId = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const pr = tap((res) => {
                dispatch(new Msg(3, [false]));
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 1: {
                            errorToast(setCtx, "addEventEmptyName", "Kunne ikke legge til kurs", "Navn kan ikke være tomt", undefined);
                            break;
                        }
                        case 2: {
                            errorToast(setCtx, "addEventEmptySummary", "Kunne ikke legge til kurs", "Sammendrag kan ikke være tomt", undefined);
                            break;
                        }
                        case 3: {
                            errorToast(setCtx, "addEventEmptyAddress", "Kunne ikke legge til kurs", "Adresse kan ikke være tom", undefined);
                            break;
                        }
                        case 4: {
                            errorToast(setCtx, "addEventInvalidTeacher", "Kunne ikke legge til kurs", "Ugyldig kursholder", undefined);
                            break;
                        }
                        case 5: {
                            errorToast(setCtx, "addEventInvalidCourse", "Kunne ikke legge til kurs", "Ugyldig kursmal", undefined);
                            break;
                        }
                        case 6: {
                            errorToast(setCtx, "addEventInvalidRegion", "Kunne ikke legge til kurs", "Ugyldig region", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, "addEventNegativeMaxAttendees", "Kunne ikke legge til kurs", "Antall plasser kan ikke være negativt", undefined);
                    }
                }
                else {
                    const e = res.fields[0];
                    appendEvent(e);
                    successToast(setCtx, "addEventSuccess", "Kurs lagt til", `Kurset ${e.Name} ble lagt til`);
                    dispatch(new Msg(2, [false]));
                    dispatch(new Msg(0, [undefined]));
                }
            }, startAsPromise(Event$.Add(new NewEvent(form.Name, form.Enabled, form.Summary, form.Description, address, form.MaxAttendees, toUniversalTime(form.Time), teacherId, form.CourseId, regionId))));
            void (pr.catch((arg) => {
                const _arg = toastServerError(setCtx, arg);
                dispatch(new Msg(3, [false]));
            }));
            break;
        }
        case 1: {
            errorToast(setCtx, "addEventFormNotFilled", "Kunne ikke legge til kurs", "Noen påkrevde felter er ikke fylt inn", undefined);
            dispatch(new Msg(3, [false]));
            break;
        }
    }
}

class ComboboxOption$1 extends Record {
    constructor(children, value, disabled) {
        super();
        this.children = children;
        this.value = value;
        this.disabled = disabled;
    }
}

function ComboboxOption$1_$reflection(gen0) {
    return record_type("AddEvent.ComboboxOption`1", [gen0], ComboboxOption$1, () => [["children", gen0], ["value", string_type], ["disabled", bool_type]]);
}

function TeacherSearchBox(teacherSearchBoxInputProps) {
    let elems_1, config, el_4, options_1_1, config_1;
    const dispatch = teacherSearchBoxInputProps.dispatch;
    const model = teacherSearchBoxInputProps.model;
    const users = teacherSearchBoxInputProps.users;
    const patternInput = reactApi.useState("");
    const query = patternInput[0];
    const options = toList(delay(() => map((user_1) => {
        let elems, el, el_2;
        return new ComboboxOption$1(singleton(createElement("div", createObj(ofArray([["key", `${user_1.Id}`], ["style", {
            display: "flex",
            gap: 5 + "px ",
            alignItems: "center",
        }], (elems = [(el = Avatar, createElement(el, {
            image: {
                src: defaultArg(user_1.ImageUrl, ""),
            },
            name: `${user_1.FirstName} ${user_1.LastName}`,
        })), (el_2 = Text$, createElement(el_2, {
            children: `${user_1.FirstName} ${user_1.LastName}`,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), int32ToString(user_1.Id), false);
    }, sortBy((user) => (`${user.FirstName} ${user.LastName}`), users, {
        Compare: comparePrimitives,
    }))));
    const el_6 = Combobox;
    return createElement(el_6, createObj(ofArray([["disabled", model.Form == null], ["placeholder", "Søk etter bruker"], ["value", query], ["onChange", (ev) => {
        patternInput[1](ev.target.value);
    }], ["onOptionSelect", (_arg_1, value_1_7) => {
        const selectedUserId = map_1((_arg) => _arg.Id, bind((userId) => tryFind((user_2) => (int32ToString(user_2.Id) === userId), users), value_1_7.optionValue));
        iterate((form) => {
            dispatch(new Msg(0, [new NewEventForm(form.Name, form.Enabled, form.Summary, form.Description, form.Address, form.MaxAttendees, form.Time, selectedUserId, form.CourseId, form.RegionId)]));
        }, toArray(model.Form));
    }], (elems_1 = ((config = ofArray([["noOptionsMessage", (el_4 = Text$, createElement(el_4, {
        children: "Ingen brukere passer søket",
    }))], ["filter", (delegateArg, delegateArg_1) => {
        const input = delegateArg_1;
        return defaultArg(map_1((user_4) => {
            if (user_4.FirstName.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) >= 0) {
                return true;
            }
            else {
                return user_4.LastName.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) >= 0;
            }
        }, tryFind((user_3) => (int32ToString(user_3.Id) === delegateArg), users)), false);
    }]]), (options_1_1 = toArray_1(options), (config_1 = createObj(config), useComboboxFilter([query, options_1_1, config_1][0], [query, options_1_1, config_1][1], [query, options_1_1, config_1][2]))))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
}

export function Dialog(dialogInputProps) {
    let elems_36, el_4, el_2, el, el_98, elems_35, el_96, elems_34, el_6, el_84, elems_32, el_94, elems_33, el_88, el_86, el_92, el_90, matchValue_31, form_24, elemsToUse;
    const appendEvent = dialogInputProps.appendEvent;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const el_100 = Dialog_1;
    return createElement(el_100, createObj(ofArray([["open", model_1.IsOpen], ["onOpenChange", (_arg, value_1_1) => {
        dispatch(new Msg(2, [value_1_1.open]));
    }], (elems_36 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = AddRegular, createElement(el, {})),
            appearance: "primary",
            children: "Nytt kurs",
            onClick: (_arg_1) => {
                if (model_1.Prerequisites == null) {
                    Promises_fetchPrerequisites(dispatch, setCtx);
                }
            },
        })),
    })), (el_98 = DialogSurface, createElement(el_98, createObj(ofArray([["style", createObj(toList(delay(() => (isMobile ? singleton_1(["width", 90 + "vw"]) : singleton_1(["minWidth", 700])))))], (elems_35 = [(el_96 = DialogBody, createElement(el_96, createObj(ofArray([["style", {
        minHeight: 700,
    }], (elems_34 = [(el_6 = DialogTitle, createElement(el_6, {
        children: "Opprett et nytt kurs",
    })), (el_84 = DialogContent, createElement(el_84, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    }], (elems_32 = toList(delay(() => {
        let elems_26, elems, el_8, el_10;
        const matchValue = model_1.Prerequisites;
        if (matchValue != null) {
            const prerequisites = matchValue;
            const allAdmins = prerequisites.AllUsers.filter((_arg_2) => _arg_2.IsAdmin);
            return append(singleton_1(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton_1(["display", "flex"]), delay(() => append(isMobile ? append(singleton_1(["flexDirection", "column"]), delay(() => singleton_1(["gap", 10 + "px "]))) : singleton_1(["flexDirection", "row"]), delay(() => singleton_1(["width", 100 + "%"]))))))))], (elems_26 = toList(delay(() => {
                let elems_13, elems_4, el_21, elems_8, el_30, matchValue_4, el_27, elems_6, elems_10, el_35, matchValue_6, el_32, elems_12, el_40;
                return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 10 + "px ",
                }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_4 = [(el_21 = Field, createElement(el_21, createObj(toList(delay(() => append(singleton_1(["label", "Kursmal"]), delay(() => append(singleton_1(["required", true]), delay(() => {
                    let el_12;
                    return append((model_1.Form == null) ? append(singleton_1(["validationMessageIcon", (el_12 = InfoRegular, createElement(el_12, {}))]), delay(() => append(singleton_1(["validationMessage", "Start med å velge en kursmal"]), delay(() => singleton_1(["validationState", "none"]))))) : empty(), delay(() => {
                        let matchValue_3, el_18, elems_2;
                        return singleton_1(["children", (matchValue_3 = tryHead([(el_18 = Dropdown, createElement(el_18, createObj(ofArray([["value", defaultArg(map_1((_arg_3) => _arg_3.Name, bind((form) => tryFind((course) => (course.Id === form.CourseId), prerequisites.AllCourses), model_1.Form)), "")], ["onOptionSelect", (_arg_5, value_1_12) => {
                            iterate((selected) => {
                                const selectedCourse = tryFind((course_1) => (course_1.Name === selected), prerequisites.AllCourses);
                                const matchValue_1 = model_1.Form;
                                if (selectedCourse != null) {
                                    if (matchValue_1 != null) {
                                        const course_3 = selectedCourse;
                                        const form_1 = matchValue_1;
                                        dispatch(new Msg(0, [new NewEventForm(course_3.Name, false, course_3.Summary, course_3.Description, form_1.Address, form_1.MaxAttendees, form_1.Time, form_1.TeacherId, course_3.Id, form_1.RegionId)]));
                                    }
                                    else {
                                        const course_2 = selectedCourse;
                                        dispatch(new Msg(0, [new NewEventForm(course_2.Name, false, course_2.Summary, course_2.Description, undefined, 0, create(year(utcNow()), month(utcNow()), day(utcNow()) + 7, 17, 0, 0), ctx.User.Id, course_2.Id, map_1((_arg_4) => _arg_4.Region.Id, ctx.User.Workplace))]));
                                    }
                                }
                            }, toArray(value_1_12.optionValue));
                        }], (elems_2 = toList(delay(() => map((course_4) => {
                            let elems_1, el_14;
                            const el_16 = Option;
                            return createElement(el_16, createObj(ofArray([["value", course_4.Name], ["text", course_4.Name], (elems_1 = [(el_14 = Text$, createElement(el_14, {
                                children: course_4.Name,
                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
                        }, sortBy((_arg_6) => _arg_6.Name, prerequisites.AllCourses, {
                            Compare: comparePrimitives,
                        })))), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (matchValue_3 == null) ? defaultOf() : matchValue_3)]);
                    }));
                })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_8 = [(el_30 = Field, createElement(el_30, {
                    label: "Region",
                    required: true,
                    children: (matchValue_4 = tryHead([(el_27 = Dropdown, createElement(el_27, createObj(ofArray([["disabled", model_1.Form == null], ["value", defaultArg(map_1((_arg_7) => _arg_7.Name, bind((form_2) => tryFind((region) => equals(region.Id, form_2.RegionId), prerequisites.AllRegions), model_1.Form)), "")], ["onOptionSelect", (_arg_9, value_1_19) => {
                        iterate((selected_1) => {
                            const selectedRegionId = map_1((_arg_8) => _arg_8.Id, tryFind((region_1) => (region_1.Name === selected_1), prerequisites.AllRegions));
                            iterate((form_3) => {
                                dispatch(new Msg(0, [new NewEventForm(form_3.Name, form_3.Enabled, form_3.Summary, form_3.Description, form_3.Address, form_3.MaxAttendees, form_3.Time, form_3.TeacherId, form_3.CourseId, selectedRegionId)]));
                            }, toArray(model_1.Form));
                        }, toArray(value_1_19.optionValue));
                    }], (elems_6 = toList(delay(() => map((region_2) => {
                        let elems_5, el_23;
                        const el_25 = Option;
                        return createElement(el_25, createObj(ofArray([["value", region_2.Name], ["text", region_2.Name], (elems_5 = [(el_23 = Text$, createElement(el_23, {
                            children: region_2.Name,
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
                    }, sortBy((_arg_10) => _arg_10.Name, prerequisites.AllRegions, {
                        Compare: comparePrimitives,
                    })))), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))]), (matchValue_4 == null) ? defaultOf() : matchValue_4),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_10 = [(el_35 = Field, createElement(el_35, {
                    label: "Antall plasser",
                    required: true,
                    children: (matchValue_6 = tryHead([(el_32 = SpinButton, createElement(el_32, createObj(toList(delay(() => append(singleton_1(["style", {
                        minWidth: 250,
                    }]), delay(() => {
                        const matchValue_5 = model_1.Form;
                        if (matchValue_5 != null) {
                            const form_4 = matchValue_5;
                            return append(singleton_1(["value", form_4.MaxAttendees]), delay(() => append(singleton_1(["min", 0]), delay(() => append(singleton_1(["max", 1000]), delay(() => singleton_1(["onChange", (_arg_11, value_1_29) => {
                                const d_1 = value_1_29;
                                iterate((maxAttendees) => {
                                    dispatch(new Msg(0, [new NewEventForm(form_4.Name, form_4.Enabled, form_4.Summary, form_4.Description, form_4.Address, (maxAttendees < 1000) ? maxAttendees : 1000, form_4.Time, form_4.TeacherId, form_4.CourseId, form_4.RegionId)]));
                                }, toArray(orElseWith(d_1.value, () => {
                                    if (isNullOrWhiteSpace(d_1.displayValue)) {
                                        return undefined;
                                    }
                                    else if (forAll(isNumber, d_1.displayValue.split(""))) {
                                        return parse(d_1.displayValue, 511, false, 32);
                                    }
                                    else {
                                        return undefined;
                                    }
                                })));
                            }])))))));
                        }
                        else {
                            return append(singleton_1(["disabled", true]), delay(() => singleton_1(["value", 0])));
                        }
                    })))))))]), (matchValue_6 == null) ? defaultOf() : matchValue_6),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_12 = [(el_40 = Field, createElement(el_40, createObj(toList(delay(() => append(singleton_1(["label", "Adresse"]), delay(() => append(singleton_1(["required", true]), delay(() => {
                    let matchValue_7, matchValue_8, address_1;
                    return append((matchValue_7 = model_1.Form, (matchValue_7 != null) ? ((matchValue_8 = matchValue_7.Address, (matchValue_8 != null) ? (isNullOrWhiteSpace(matchValue_8) ? ((address_1 = matchValue_8, append(singleton_1(["validationMessage", "Adressefelt kan ikke være tomt"]), delay(() => singleton_1(["validationState", "error"]))))) : (empty())) : (empty()))) : (empty())), delay(() => {
                        let matchValue_10, el_37;
                        return singleton_1(["children", (matchValue_10 = tryHead([(el_37 = Input, createElement(el_37, createObj(toList(delay(() => append(singleton_1(["style", {
                            minWidth: 250,
                        }]), delay(() => {
                            const matchValue_9 = model_1.Form;
                            if (matchValue_9 != null) {
                                const form_6 = matchValue_9;
                                return append(singleton_1(["value", defaultArg(form_6.Address, "")]), delay(() => singleton_1(["onChange", (_arg_12, value_1_36) => {
                                    dispatch(new Msg(0, [new NewEventForm(form_6.Name, form_6.Enabled, form_6.Summary, form_6.Description, value_1_36.value, form_6.MaxAttendees, form_6.Time, form_6.TeacherId, form_6.CourseId, form_6.RegionId)]));
                                }])));
                            }
                            else {
                                return append(singleton_1(["disabled", true]), delay(() => singleton_1(["value", ""])));
                            }
                        })))))))]), (matchValue_10 == null) ? defaultOf() : matchValue_10)]);
                    }));
                })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))), delay(() => {
                    let el_42;
                    return append(!isMobile ? singleton_1((el_42 = Divider, createElement(el_42, {
                        vertical: true,
                    }))) : empty(), delay(() => {
                        let elems_25, elems_15, el_47, elems_19, el_58, elems_21, el_63, elems_23, el_68, elems_24, el_72, el_70;
                        return singleton_1(createElement("div", createObj(ofArray([["style", {
                            minWidth: 280,
                            display: "flex",
                            flexDirection: "column",
                            gap: 10 + "px ",
                        }], (elems_25 = [createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_15 = [(el_47 = Field, createElement(el_47, createObj(toList(delay(() => append(singleton_1(["label", "Navn"]), delay(() => append(singleton_1(["required", true]), delay(() => {
                            let matchValue_11, form_8;
                            return append((matchValue_11 = model_1.Form, (matchValue_11 != null) ? (isNullOrWhiteSpace(matchValue_11.Name) ? ((form_8 = matchValue_11, append(singleton_1(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton_1(["validationState", "error"]))))) : (empty())) : (empty())), delay(() => {
                                let matchValue_13, el_44;
                                return singleton_1(["children", (matchValue_13 = tryHead([(el_44 = Input, createElement(el_44, createObj(toList(delay(() => append(singleton_1(["style", {
                                    minWidth: 250,
                                }]), delay(() => {
                                    const matchValue_12 = model_1.Form;
                                    if (matchValue_12 != null) {
                                        const form_9 = matchValue_12;
                                        return append(singleton_1(["value", form_9.Name]), delay(() => singleton_1(["onChange", (_arg_13, value_1_44) => {
                                            dispatch(new Msg(0, [new NewEventForm(value_1_44.value, form_9.Enabled, form_9.Summary, form_9.Description, form_9.Address, form_9.MaxAttendees, form_9.Time, form_9.TeacherId, form_9.CourseId, form_9.RegionId)]));
                                        }])));
                                    }
                                    else {
                                        return append(singleton_1(["disabled", true]), delay(() => singleton_1(["value", ""])));
                                    }
                                })))))))]), (matchValue_13 == null) ? defaultOf() : matchValue_13)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_19 = [(el_58 = Field, createElement(el_58, createObj(toList(delay(() => append(singleton_1(["label", "Kursholder"]), delay(() => append(singleton_1(["required", true]), delay(() => {
                            let matchValue_14, form_11;
                            return append((matchValue_14 = model_1.Form, (matchValue_14 != null) ? ((matchValue_14.TeacherId == null) ? ((form_11 = matchValue_14, append(singleton_1(["validationMessage", "Kurset må ha en kursholder"]), delay(() => singleton_1(["validationState", "error"]))))) : (empty())) : (empty())), delay(() => {
                                let matchValue_17;
                                return singleton_1(["children", (matchValue_17 = tryHead(toList(delay(() => {
                                    let elems_17, elems_16, el_49, el_51, el_55, el_53;
                                    const matchValue_15 = model_1.Form;
                                    if (matchValue_15 == null) {
                                        return singleton_1(createElement(TeacherSearchBox, {
                                            users: allAdmins,
                                            model: model_1,
                                            dispatch: dispatch,
                                        }));
                                    }
                                    else {
                                        const form_12 = matchValue_15;
                                        const matchValue_16 = tryFind((user) => equals(user.Id, form_12.TeacherId), prerequisites.AllUsers);
                                        if (matchValue_16 != null) {
                                            const teacher$0027 = matchValue_16;
                                            return singleton_1(createElement("div", createObj(ofArray([["style", {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                minWidth: 250,
                                            }], (elems_17 = [createElement("div", createObj(ofArray([["style", {
                                                display: "flex",
                                                gap: 5 + "px ",
                                                alignItems: "center",
                                            }], (elems_16 = [(el_49 = Avatar, createElement(el_49, {
                                                image: {
                                                    src: defaultArg(teacher$0027.ImageUrl, ""),
                                                },
                                                name: `${teacher$0027.FirstName} ${teacher$0027.LastName}`,
                                            })), (el_51 = Text$, createElement(el_51, {
                                                children: `${teacher$0027.FirstName} ${teacher$0027.LastName}`,
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))), (el_55 = Button, createElement(el_55, {
                                                appearance: "transparent",
                                                icon: (el_53 = DismissRegular, createElement(el_53, {})),
                                                onClick: (_arg_14) => {
                                                    dispatch(new Msg(0, [new NewEventForm(form_12.Name, form_12.Enabled, form_12.Summary, form_12.Description, form_12.Address, form_12.MaxAttendees, form_12.Time, undefined, form_12.CourseId, form_12.RegionId)]));
                                                },
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_17))])]))));
                                        }
                                        else {
                                            return singleton_1(createElement(TeacherSearchBox, {
                                                users: allAdmins,
                                                model: model_1,
                                                dispatch: dispatch,
                                            }));
                                        }
                                    }
                                }))), (matchValue_17 == null) ? defaultOf() : matchValue_17)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_19))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_21 = [(el_63 = Field, createElement(el_63, createObj(toList(delay(() => append(singleton_1(["label", "Publiser"]), delay(() => {
                            let matchValue_18, form_14;
                            return append((matchValue_18 = model_1.Form, (matchValue_18 != null) ? (matchValue_18.Enabled ? ((form_14 = matchValue_18, singleton_1(["hint", "Kurset publiseres med en gang, og blir synlig for alle"]))) : singleton_1(["hint", "Kurset lagres som utkast, og blir ikke synlig for alle"])) : singleton_1(["hint", "Kurset lagres som utkast, og blir ikke synlig for alle"])), delay(() => {
                                let matchValue_20, el_60;
                                return singleton_1(["children", (matchValue_20 = tryHead([(el_60 = Switch, createElement(el_60, createObj(toList(delay(() => {
                                    const matchValue_19 = model_1.Form;
                                    if (matchValue_19 != null) {
                                        const form_15 = matchValue_19;
                                        return append(singleton_1(["checked", form_15.Enabled]), delay(() => singleton_1(["onChange", (_arg_15, value_1_58) => {
                                            dispatch(new Msg(0, [new NewEventForm(form_15.Name, value_1_58.checked, form_15.Summary, form_15.Description, form_15.Address, form_15.MaxAttendees, form_15.Time, form_15.TeacherId, form_15.CourseId, form_15.RegionId)]));
                                        }])));
                                    }
                                    else {
                                        return append(singleton_1(["disabled", true]), delay(() => singleton_1(["checked", false])));
                                    }
                                })))))]), (matchValue_20 == null) ? defaultOf() : matchValue_20)]);
                            }));
                        })))))))], ["children", reactApi.Children.toArray(Array.from(elems_21))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_23 = [(el_68 = Field, createElement(el_68, createObj(toList(delay(() => append(singleton_1(["label", "Dato"]), delay(() => append(singleton_1(["required", true]), delay(() => {
                            let matchValue_21, form_17;
                            return append((matchValue_21 = model_1.Form, (matchValue_21 != null) ? ((compare(matchValue_21.Time, now()) <= 0) ? ((form_17 = matchValue_21, append(singleton_1(["validationMessage", "Kurs kan ikke være i fortiden"]), delay(() => singleton_1(["validationState", "error"]))))) : (empty())) : (empty())), delay(() => {
                                let matchValue_23, el_65;
                                return singleton_1(["children", (matchValue_23 = tryHead([(el_65 = DatePicker, createElement(el_65, createObj(toList(delay(() => append(singleton_1(["formatDate", (delegateArg) => {
                                    const locale = nb;
                                    const formatOptions = {};
                                    formatOptions.locale = locale;
                                    return format_1(delegateArg, "EEEE dd MMMM yyyy", formatOptions);
                                }]), delay(() => append(singleton_1(["minDate", setHours(utcNow(), 0)]), delay(() => {
                                    const matchValue_22 = model_1.Form;
                                    if (matchValue_22 != null) {
                                        const form_18 = matchValue_22;
                                        return append(singleton_1(["value", form_18.Time]), delay(() => singleton_1(["onSelectDate", (delegateArg_1) => {
                                            iterate((date_2) => {
                                                dispatch(new Msg(0, [new NewEventForm(form_18.Name, form_18.Enabled, form_18.Summary, form_18.Description, form_18.Address, form_18.MaxAttendees, create(year(date_2), month(date_2), day(date_2), hour(form_18.Time), minute(form_18.Time), 0), form_18.TeacherId, form_18.CourseId, form_18.RegionId)]));
                                            }, toArray(delegateArg_1));
                                        }])));
                                    }
                                    else {
                                        return append(singleton_1(["disabled", true]), delay(() => singleton_1(["value", utcNow()])));
                                    }
                                })))))))))]), (matchValue_23 == null) ? defaultOf() : matchValue_23)]);
                            }));
                        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_23))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_24 = [(el_72 = Field, createElement(el_72, {
                            required: true,
                            label: "Tidspunkt",
                            children: (el_70 = TimePicker, createElement(el_70, createObj(toList(delay(() => append(singleton_1(["hourCycle", "h23"]), delay(() => append(singleton_1(["increment", 15]), delay(() => {
                                const matchValue_24 = model_1.Form;
                                if (matchValue_24 != null) {
                                    const form_19 = matchValue_24;
                                    return append(singleton_1(["selectedTime", form_19.Time]), delay(() => singleton_1(["onTimeChange", (_arg_17, value_1_74) => {
                                        const dt_1 = TimeSelectionDataModule_parse(value_1_74);
                                        iterate((time) => {
                                            dispatch(new Msg(0, [new NewEventForm(form_19.Name, form_19.Enabled, form_19.Summary, form_19.Description, form_19.Address, form_19.MaxAttendees, create(year(form_19.Time), month(form_19.Time), day(form_19.Time), hour(time), minute(time), 0), form_19.TeacherId, form_19.CourseId, form_19.RegionId)]));
                                        }, toArray(orElseWith(dt_1.selectedTime, () => bind((timeString) => {
                                            let matchValue_25;
                                            let outArg = minValue();
                                            matchValue_25 = [tryParse(timeString, new FSharpRef(() => outArg, (v_4) => {
                                                outArg = v_4;
                                            })), outArg];
                                            if (matchValue_25[0]) {
                                                return matchValue_25[1];
                                            }
                                            else {
                                                return undefined;
                                            }
                                        }, dt_1.selectedTimeText))));
                                    }])));
                                }
                                else {
                                    return append(singleton_1(["selectedTime", now()]), delay(() => singleton_1(["disabled", true])));
                                }
                            }))))))))),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_24))])])))], ["children", reactApi.Children.toArray(Array.from(elems_25))])]))));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_26))])])))), delay(() => {
                let elems_31, elems_28, el_77, elems_30, el_82;
                return singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 10 + "px ",
                    width: 100 + "%",
                }], (elems_31 = [createElement("div", createObj(ofArray([["style", {
                    minHeight: 100,
                }], (elems_28 = [(el_77 = Field, createElement(el_77, createObj(toList(delay(() => append(singleton_1(["label", "Sammendrag"]), delay(() => append(singleton_1(["required", true]), delay(() => {
                    let matchValue_26, form_20;
                    return append((matchValue_26 = model_1.Form, (matchValue_26 != null) ? ((form_20 = matchValue_26, isNullOrWhiteSpace(form_20.Summary) ? append(singleton_1(["validationMessage", "Sammendrag kan ikke være tomt"]), delay(() => singleton_1(["validationState", "error"]))) : append(singleton_1(["validationMessage", `${form_20.Summary.length}/250`]), delay(() => singleton_1(["validationState", "none"]))))) : (empty())), delay(() => {
                        let matchValue_28, el_74;
                        return singleton_1(["children", (matchValue_28 = tryHead([(el_74 = Textarea, createElement(el_74, createObj(toList(delay(() => append(singleton_1(["resize", "vertical"]), delay(() => {
                            const matchValue_27 = model_1.Form;
                            if (matchValue_27 != null) {
                                const form_21 = matchValue_27;
                                return append(singleton_1(["value", form_21.Summary]), delay(() => singleton_1(["onChange", (_arg_18, value_1_83) => {
                                    const d_3 = value_1_83;
                                    if (d_3.value.length <= 250) {
                                        dispatch(new Msg(0, [new NewEventForm(form_21.Name, form_21.Enabled, d_3.value, form_21.Description, form_21.Address, form_21.MaxAttendees, form_21.Time, form_21.TeacherId, form_21.CourseId, form_21.RegionId)]));
                                    }
                                }])));
                            }
                            else {
                                return append(singleton_1(["disabled", true]), delay(() => singleton_1(["value", ""])));
                            }
                        })))))))]), (matchValue_28 == null) ? defaultOf() : matchValue_28)]);
                    }));
                })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_28))])]))), createElement("div", createObj(ofArray([["style", {
                    minHeight: 200,
                }], (elems_30 = [(el_82 = Field, createElement(el_82, createObj(toList(delay(() => append(singleton_1(["label", "Beskrivelse"]), delay(() => append(defaultArg(map_1((description) => ofArray([["validationMessage", `${description.length}/5000`], ["validationState", "none"]]), bind((_arg_19) => _arg_19.Description, model_1.Form)), empty_1()), delay(() => {
                    let matchValue_30, el_79;
                    return singleton_1(["children", (matchValue_30 = tryHead([(el_79 = Textarea, createElement(el_79, createObj(toList(delay(() => append(singleton_1(["resize", "vertical"]), delay(() => append(singleton_1(["style", {
                        minHeight: 150,
                    }]), delay(() => {
                        const matchValue_29 = model_1.Form;
                        if (matchValue_29 != null) {
                            const form_22 = matchValue_29;
                            return append(singleton_1(["value", defaultArg(form_22.Description, "")]), delay(() => singleton_1(["onChange", (_arg_20, value_1_89) => {
                                const d_4 = value_1_89;
                                if (d_4.value.length <= 5000) {
                                    dispatch(new Msg(0, [new NewEventForm(form_22.Name, form_22.Enabled, form_22.Summary, d_4.value, form_22.Address, form_22.MaxAttendees, form_22.Time, form_22.TeacherId, form_22.CourseId, form_22.RegionId)]));
                                }
                            }])));
                        }
                        else {
                            return append(singleton_1(["disabled", true]), delay(() => singleton_1(["value", ""])));
                        }
                    })))))))))]), (matchValue_30 == null) ? defaultOf() : matchValue_30)]);
                })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_30))])])))], ["children", reactApi.Children.toArray(Array.from(elems_31))])]))));
            }));
        }
        else {
            return singleton_1(createElement("div", createObj(ofArray([["style", {
                width: 100 + "%",
                height: 100 + "%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: 15,
            }], (elems = [(el_8 = WarningRegular, createElement(el_8, {
                primaryFill: tokens.colorStatusWarningForeground1,
                fontSize: 82,
            })), (el_10 = Caption1, createElement(el_10, {
                children: "Noe gikk galt - vennligst prøv igjen senere",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_32))])])))), (el_94 = DialogActions, createElement(el_94, createObj(ofArray([["position", "end"], (elems_33 = [(el_88 = Button, createElement(el_88, {
        icon: (el_86 = DismissRegular, createElement(el_86, {})),
        children: "Avbryt",
        onClick: (_arg_21) => {
            dispatch(new Msg(2, [false]));
            dispatch(new Msg(0, [undefined]));
        },
    })), (el_92 = Button, createElement(el_92, {
        icon: (el_90 = SaveRegular, createElement(el_90, {})),
        appearance: "primary",
        onClick: (_arg_22) => {
            dispatch(new Msg(3, [true]));
            iterate((form_23) => {
                Promises_addEvent(form_23, appendEvent, dispatch, setCtx);
            }, toArray(model_1.Form));
        },
        disabled: (matchValue_31 = model_1.Form, (matchValue_31 != null) ? ((form_24 = matchValue_31, (((((((isNullOrWhiteSpace(form_24.Name) ? true : isNullOrWhiteSpace(form_24.Summary)) ? true : defaultArg(map_1(isNullOrWhiteSpace, form_24.Address), true)) ? true : (form_24.MaxAttendees <= 0)) ? true : (form_24.MaxAttendees > 1000)) ? true : (form_24.TeacherId == null)) ? true : (form_24.RegionId == null)) ? true : (compare(form_24.Time, now()) <= 0)) ? true : model_1.IsSending)) : true),
        children: model_1.IsSending ? "Sender..." : "Legg til",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_33))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_34))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_35))])]))))], (elemsToUse = ((length(elems_36) <= 2) ? elems_36 : take(2, elems_36)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=AddEvent.jsx.map
